import { h, render } from 'preact';

export default ({ children, ...props}) => {
    
    const { css, url, className, style, size } = props;

    return (
        <a href={url || '#'} class={`button ${style ? 'button_style-'+style : ''} ${size ? 'button_size-'+size : ''} ${className || ''}`} style={css || {}}>
            <span class="button__wrapper">{ children }</span>
        </a>
    )
}